import type { Components } from '@mui/material/styles/components';
import type { Theme } from '@mui/material/styles/createTheme';

export const MuiToggleButtonGroup: Components<Theme>['MuiToggleButtonGroup'] = {
  styleOverrides: {
    root: {
      display: 'grid',
      marginTop: '10px',
      gap: '10px',
    },
    grouped: {
      borderColor: '#EEF2FD',
      backgroundColor: '#EEF2FD',
      borderRadius: '10px !important',
      fontSize: '14px',
      lineHeight: 1.5,
      fontWeight: 500,
      color: '#2A3040',
      textTransform: 'none',
      padding: '9px',
      '&.Mui-selected': {
        backgroundColor: '#6948EB',
        color: '#FFFFFF',
        borderColor: '#6948EB',
        '&.Mui-error': {
          backgroundColor: '#E02727',
          borderColor: '#E02727',
        },
        '&:hover': {
          backgroundColor: '#5E3CE1',
          borderColor: '#5E3CE1',
          '&.Mui-error': {
            backgroundColor: '#E02727',
            borderColor: '#E02727',
          },
        },
      },
    },
  },
};
